import React from "react";

function Loader({ style }) {
    return (
        <div className="tnb-trpr--loader" style={style}>
            <div className="tnb-trpr--wrapper">
                <i className="tnb-trpr--icon trpr__icon-trip-planner" />
                <div className="tnb-trpr--loading-bar">
                    <div className="tnb-trpr--indicator" />
                </div>
            </div>
        </div>
    );
}

export default Loader;
